import { t } from '../i18n/index.js';
import type { PmConversation } from '../../shared/protocol.js';

/**
 * Unread private messages found at login (decision 2026-09-29): a clear notice with the senders
 * and a link to the Messages page. Disappears when the messages are read or the notice is closed.
 */
export function PmLoginNotice(props: { unread: PmConversation[]; onDismiss: () => void }) {
  const total = props.unread.reduce((sum, c) => sum + c.unread, 0);
  const names = props.unread.map((c) => (c.unread > 1 ? `${c.with.displayName} (${c.unread})` : c.with.displayName)).join(', ');
  return (
    <div class="pm-login-notice" role="status">
      <span class="pm-login-icon" aria-hidden="true">
        📬
      </span>
      <div class="pm-login-text">
        <strong>{t.messages.loginNotice(total)}</strong>
        <span>{t.messages.loginFrom(names)}</span>
      </div>
      <a class="btn btn-primary btn-small" href="#/viestit">
        {t.messages.read}
      </a>
      <button class="btn btn-ghost btn-small" onClick={props.onDismiss} aria-label={t.messages.dismiss} title={t.messages.dismiss}>
        ×
      </button>
    </div>
  );
}
